const ADVANCE_DIAGNOSTICS_UNIT = {
	unitCode: '463870544',
	stateCode: 'SP',
	stateName: 'SAO PAULO',
	cityName: 'SAO PAULO',
	districtName: 'JARDIM PAULISTA',
	citiesNames: 'SAO PAULO',
};

export {ADVANCE_DIAGNOSTICS_UNIT};
